module.exports = __webpack_public_path__ + "img/logo_bg_white.4390bef2.svg";